import PolicyLayout from './PolicyLayout';
import {
  ADDRESS,
  COMPANY_NAME,
  LEGAL_UPDATED,
  SITE_DOMAIN,
  SITE_NAME,
} from '../constants/site';

export default function Disclaimer() {
  return (
    <PolicyLayout
      title="Disclaimer"
      updated={LEGAL_UPDATED}
      showDisclaimer={false}
      intro={`The information on ${SITE_DOMAIN} (${SITE_NAME}) is published in good faith for general guidance. This page explains the limits of what we claim and what you should independently verify.`}
    >
      <h2>Independent operator</h2>
      <p>
        {SITE_DOMAIN} is operated by <strong>{COMPANY_NAME}</strong>, {ADDRESS}.
        We sell <strong>design software</strong> and{' '}
        <strong>digital marketing tools</strong> and provide related customer
        support. We are not affiliated with, endorsed by, or sponsored by any
        software publisher unless a product page clearly states otherwise.
      </p>

      <h2>Trademarks</h2>
      <p>
        Product names, logos, and trademarks that appear on this website belong
        to their respective owners. They are used for identification only and do
        not imply endorsement, sponsorship, or partnership.
      </p>

      <h2>Accuracy of information</h2>
      <p>
        We work to keep pricing, feature summaries, and system notes accurate.
        Specifications and availability can change. We do not warrant that all
        content is complete, current, or error-free, and we may correct
        inaccuracies at any time.
      </p>

      <h2>Pricing disclaimer</h2>
      <p>
        Advertised prices may be promotional, limited by time or quantity, or
        vary by region. Taxes may apply. The price confirmed at checkout is the
        price that applies to your order.
      </p>

      <h2>Not professional advice</h2>
      <p>
        Guides and marketing tips on this website are general information, not
        legal, financial, or professional consulting advice. For specialised
        advice, engage a qualified professional.
      </p>

      <h2>Results not guaranteed</h2>
      <p>
        Design outcomes and marketing results depend on your skills, budget,
        audience, and execution. Software tools assist work; they do not
        guarantee business results.
      </p>

      <h2>External links</h2>
      <p>
        This website may link to external sites we do not operate. We are not
        responsible for their content, privacy practices, or availability.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        Under no circumstances shall {COMPANY_NAME} be liable for any loss or
        damage incurred from using this website or relying on information
        published here. Use of the site is at your own risk.
      </p>

      <h2>Consent</h2>
      <p>
        By continuing to use this website, you consent to this disclaimer. If you
        do not agree, please discontinue use of the site.
      </p>
    </PolicyLayout>
  );
}
